/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import { rect, rectsEqual } from '../rect'




export default class Drawable {

    constructor(frame) {
        this._parent = null
        this._frame = frame ? frame : rect(0, 0, 10, 10)
        this._bounds = rect(0, 0, this._frame.w, this._frame.h)
        this._needsDraw = true
        this._fill = null
        this._stroke = null
        this._lineWidth = 1
        this._children = []
    }

    get cacheKey() {
        let key = ''
        key += this.__proto__.constructor.name + '-'
        key += this._frame.w + '-'
        key += this._frame.h + '-'
        key += this._fill + '-'
        key += this._stroke + '-'
        key += this._lineWidth + '-'
        return key
    }

    add(child) {
        this.needsDraw = true
        child.needsDraw = true
        console.log('needsDraw addChild')
        child._parent = this
        this._children.push(child)
    }

    remove(child) {
        this.needsDraw = true
        console.log('needsDraw remove')
        child._parent = null
        this.children = this.children.filter(c => c !== child)
    }

    get parent() {
        return this._parent
    }

    get children() {
        return this._children
    }

    set children(val) {
        this._children = val
    }

    get frame() {
        return this._frame
    }

    set frame(val) {
        if (!rectsEqual(val, this._frame)) {
            console.log('needsDraw frame')
            this.needsDraw = true
        }
        this._frame = val
        this._bounds = rect(0, 0, val.w, val.h)
    }

    get bounds() {
        return this._bounds
    }

    set bounds(val) {
        if (! rectsEqual(val, this._bounds)) {
            console.log('needsDraw bounds')
            this.needsDraw = true
        }
        this._bounds = val
    }

    get fill() {
        return this._fill
    }

    set fill(val) {
        if (val !== this._fill) {
            console.log('needsDraw fill')
            this.needsDraw = true
        }
        this._fill = val
    }

    get stroke() {
        return this._stroke
    }

    set stroke(val) {
        if (val !== this._stroke) {
            console.log('needsDraw stroke')
            this.needsDraw = true
        }
        this._stroke = val
    }

    get lineWidth() {
        return this._lineWidth
    }

    set lineWidth(val) {
        if (val !== this._lineWidth) {
            console.log('needsDraw lineWidth')
            this.needsDraw = true
        }
        this._lineWidth = val
    }

    get needsDraw() {
        return this._needsDraw
    }

    set needsDraw(val) {
        this._needsDraw = val
        if (val === true && this.parent) {
            console.log('needsDraw parent')
            this.parent.needsDraw = true
        }
    }

    get commands() {
        return []
    }

    layout() {

    }

    draw(renderer, ctx) {
        renderer.draw(ctx, this)
        this.needsDraw = false
    }

}
